<template>
    <div>
        <label :for="id">{{label}}</label>
        <textarea
            :id="id" 
            :fieldlabel="validationFieldLabel"
            style="margin-top: 8;"
            v-model="textAreaValue"
            v-taurus-validator="'max:' + maxLength +'|required'"
            class="form-control form-control-lg"
            :rows="rows"
            :maxlength="maxLength" >
        </textarea>
        <div class="text-area-charcount-feedback">
            <div :name="id" :invalidfeedback="validationInvalidFeedback"></div>
            <char-count :inputValue="textAreaValue" :maxLength="maxLength"/>
        
        </div>
    </div>
</template>
<script>
import CharCount from '@/components/CharCount.vue'
export default {
    props: {
        value: { required: true },
        id: { required: true },
        label: { required: true },
        maxLength: { required: true },
        validationFieldLabel: {required:true},
        validationInvalidFeedback: {required:true},
        rows: { require:true }
    },
    components: {
        CharCount
    },
    data: () => {
        return {
            textAreaValue: null
        }
    },
    mounted() {
        this.textAreaValue = this.value;
    },
    watch:{
        textAreaValue(newVal) {
            this.$emit('input', this.textAreaValue);
        }
    }
}
</script>